export function PendingComponent({
	message,
	fullscreen,
}: {
	message?: string;
	fullscreen?: boolean;
}) {
	// If fullScreen is true, use fixed positioning for the entire viewport
	const fixed = (fullscreen ?? false) ? " fixed" : "";
	return (
		<div
			className={`flex flex-col gap-2 w-full h-full items-center justify-center insert-0${fixed}`}
		>
			{/* <Card>
        <CardContent className="flex gap-2"> */}

			<div className="flex space-x-2 justify-center items-center dark:invert">
				<div className="h-2 w-2 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
				<div className="h-2 w-2 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
				<div className="h-2 w-2 bg-black rounded-full animate-bounce"></div>
			</div>
			<div>{message ?? "Loading..."}</div>
			{/* </CardContent>
      </Card> */}
		</div>
	);
}
